// export const webip = "localhost:8085";
// export const apiIP = "localhost:8082";
// export const webSocketIP = "localhost:8083";
export const webip = "61.60.10.115:8085";
export const apiIP = "apitnleoenergy.smartbustw.com";
export const webSocketIP = "61.60.10.115:8083";
// export const webip = "52.230.13.131:8085";
// export const apiIP = "52.230.13.131:8082";
// export const webSocketIP = "52.230.13.131:8083";